import { BreadCrumbActions } from 'src/app/shared/components/breadcrumb/breadcrumb.actions'
import { Observable } from 'rxjs'
import { filter, startWith, switchMap, take, tap } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'

import { Course } from '../course'
import { courseActions } from '../course.actions'
import { courseSelectors } from '../course.selectors'
import { RequestQueryBuilder } from '@nestjsx/crud-request'

import { environment } from 'src/environments/environment'
import { NavigationItemTypes } from 'src/app/shared/constants'
import { productActions } from '../../product/product.actions'

@Component({
  selector: 'course-show',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class CourseShowComponent implements OnInit {
  public course$: Observable<Course>
  public courseId$: Observable<number>
  public isLoading$: Observable<boolean>
  public navigationItemTypes = NavigationItemTypes
  public courseModuleConfig = environment.moduleConfigs.courseModule
  public achievementModuleConfig = environment.moduleConfigs.achievementModule

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.isLoading$ = this.store
      .select(courseSelectors.selectIsLoading)
      .pipe(startWith(false))

    this.courseId$ = this.store
      .select(courseSelectors.selectIdRouteParam)
      .pipe(filter((id) => Boolean(id)))

    this.course$ = this.courseId$.pipe(
      switchMap((courseId) =>
        this.store.select(courseSelectors.selectById, courseId)
      )
    )
    this.courseId$.pipe(take(1)).subscribe((courseId) => {
      if (courseId) {
        if (!isNaN(Number(courseId))) {
          this.store.dispatch(
            BreadCrumbActions.initHistory({
              pageName: 'courseModule.courses',
              url: '/courses',
              titleName: ['courseModule.courses'],
              resourceType: 'courses',
              entityId: Number(courseId)
            })
          )
          this.store.dispatch(
            courseActions.fetchOneById({
              id: courseId,
              params: RequestQueryBuilder.create({
                join: [
                  { field: 'tags' },
                  { field: 'translations' },
                  { field: 'emailTemplates' },
                  { field: 'linkedSubscriptions' },
                  { field: 'linkedSubscriptions.translations' },
                  { field: 'documentTemplateParents' },
                  { field: 'documents' }
                ]
              })
            })
          )
        }
      }
    })
    this.course$.pipe(take(1)).subscribe((course) => {
      if (course?.productId) {
        this.store.dispatch(
          productActions.fetchOneById({
            id: course?.productId,
            params: RequestQueryBuilder.create({
              join: [
                { field: 'tags' },
                { field: 'documents' },
                { field: 'linkedSubscriptions' },
                { field: 'linkedSubscriptions.translations' }
              ]
            })
          })
        )
      }
    })
  }
  setTitle(name: 'relationship' | 'bookings') {
    this.courseId$.pipe(take(1)).subscribe((courseId) => {
      if (courseId) {
        setTimeout(() => {
          if (name === 'relationship') {
            this.store.dispatch(
              BreadCrumbActions.addPageToHistory({
                pageName: 'courseModule.courses',
                url: '/courses',
                titleName: ['general.tagsRelationships'],
                resourceType: 'courses',
                entityId: Number(courseId)
              })
            )
          } else {
            this.store.dispatch(
              BreadCrumbActions.addPageToHistory({
                pageName: 'courseModule.courses',
                url: '/courses',
                titleName: ['bookingModule.bookings'],
                resourceType: 'courses',
                entityId: Number(courseId)
              })
            )
          }
        }, 50)
      }
    })
  }
}
